import { Box, Grid } from '@material-ui/core'
import { Button } from 'react-admin'
import { useNavigate } from 'react-router'
import useStyles from '../styles'

const ButtonViewAllInterventions = ({ record }) => {
  const navigate = useNavigate()
  const classes = useStyles()
  const redirectToAllInterventions = () => {
    navigate(`/ext_prestas/${record?.id}`)
  }
  return (
    <Grid container justifyContent="center">
      <Grid xs={11} md={6}>
        <Box style={{ marginTop: 16, marginBottom: 16 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={redirectToAllInterventions}
            className={classes.button}
          >
            Voir toutes mes interventions en cours
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}
export default ButtonViewAllInterventions
